import styles from './FilterTabs.module.css';

export type TabFilter = 'all' | 'important' | 'my-important' | 'all-important' | 'unread' | 'unmapped' | 'flagged' | 'internal' | 'needs-attention' | 'recommended' | 'my-territory';

interface Tab {
  id: TabFilter;
  label: string;
  count: number;
  variant?: 'default' | 'urgent';
}

interface FilterTabsProps {
  activeTab: TabFilter;
  tabs: Tab[];
  onTabChange: (tab: TabFilter) => void;
}

const FilterTabs: React.FC<FilterTabsProps> = ({ activeTab, tabs, onTabChange }) => {
  return (
    <div className={styles.tabs}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''} ${tab.variant === 'urgent' ? styles.urgent : ''}`}
          onClick={() => onTabChange(tab.id)}
          type="button"
          value={tab.id}
          data-action="inbox_tab"
          data-record-value="tab"
          aria-pressed={activeTab === tab.id}
        >
          {tab.label}
          {tab.count > 0 && <span className={styles.badge}>{tab.count}</span>}
        </button>
      ))}
    </div>
  );
};

export default FilterTabs;
